import { get_source } from "./source";
export async function create_link(properties: string[],abort_signal?: any) : Promise<[number|null,Request]> {
  const url: URL = new URL('https://event-application.null-988.workers.dev');
  url.pathname = '/api/v1/create-share-link';
  properties = properties.filter((value: string) => {
    return String(value).match(/^KEY/);
  });

  const payload = {
    properties,
    source: get_source(),
  };
  let opts: any = {
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    method: 'POST',
  };
  if(abort_signal instanceof AbortSignal){
    opts.signal = abort_signal;
  }
  const request: Request = new Request(url, opts);

  const resp = await fetch(request).then(async (response) => {
    if(request.signal.aborted){
      throw new Error('Aborted');
    }
    return await response.json();
  }).catch((reason) => {
    if(request.signal.aborted){
      console.info('create_link.catch reason:',reason);
      throw new Error('Aborted');
    }
  });

  console.log(resp);
  return [resp.id,request];
}
